import { useEffect, useState } from "react";
import "./popupInstall.component.css";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import {installPWA, pwaInstalled, isIos} from "../../utilityPWA";
import moment from "moment";

// i props per il popup
export type PopupInstallProps = {
  openManually?: boolean;  // apertura manuale del popup
  showBehaviorManually?: boolean; // Indica, con l' apertura manuale, se bisogna far visualizzare il popup 
  onClosePopup?: any;
}

export default function PopupInstallComponent(props: PopupInstallProps) {
  const [showPopupInstall, setShowPopupInstall] = useState<boolean>(false);
  const [appName, setAppName] = useState('');

  useEffect(() => {

    if(!appName) {
      getAppNameFromManifest();
    }

    if(props.openManually) {
      let showPopup: boolean = props.showBehaviorManually ? true : false; 
      if(showPopup) {
        setShowPopupInstall(showPopup);
      }
    }

    else {
      // Se non è installata la pwa
      if (pwaInstalled() == false) {
        // Controllo quando è stato visualizzato l' ultima volta il popup "Installa app" e se è passato più di un giorno
        // lo visualizzo
        if (isPassedDayLastRequest()) {
          // se è passato più di un giorno
          if(window.location.pathname === '/' || window.location.pathname === '/home') {
            setShowPopupInstall(true);
          }
        }
      } else if (isPassedDayLastRequest()) {
        // altrimenti se la pwa è installata ed è passato più di un giorno dall' ultima volta che
        // è stato visualizzato il popup "Installa app", rimuovo info da localstorage
        localStorage.removeItem("REQUEST_INSTALL_TIME");
      }
    }
 
  }, [props]);

  const getAppNameFromManifest = async () => {
    try {
      let pathManifest: string = process.env.REACT_APP_PATH_MANIFEST || '';
      const response = await fetch(pathManifest);
      const manifest = await response.json();
      setAppName(manifest.name);
    } catch (error) {
      setAppName('MySalusApp');
    }
  }

  const isPassedDayLastRequest = (): boolean => {
    const now: number = moment().valueOf() * 10000 + 621355968000000000;
    const requestTime: number = parseInt(
      localStorage.getItem("REQUEST_INSTALL_TIME") || "0"
    );

    return now - requestTime >= 864 * Math.pow(10, 9);
  };

  const hiddenPopup = () => {
    setShowPopupInstall(false);
    if(props.openManually && props.onClosePopup) {
      props.onClosePopup();
    }
  }

  const footerContent = () => {
    if(props.openManually){
      return <></>
    }
    else if (isIos()) {
      return (
        <div className="flex justify-content-end align-items-center">
          <Button
            className="button-popup button-no-now"
            label="Ricordamelo più tardi"
            onClick={() => {
              const now: number =
                moment().valueOf() * 10000 + 621355968000000000; // conversione in ticks
              localStorage.setItem("REQUEST_INSTALL_TIME", JSON.stringify(now)); // salvataggio in ticks del pulsante "Ricordamelo più tardi"
              setShowPopupInstall(false);
            }}
          />
        </div>
      );
    } else {
      return (
        <div className="flex justify-content-end align-items-center">
          <Button
            className="button-popup button-no-now"
            label="Non adesso"
            onClick={() => {
              const now: number =
                moment().valueOf() * 10000 + 621355968000000000; // conversione in ticks
              localStorage.setItem("REQUEST_INSTALL_TIME", JSON.stringify(now)); // salvataggio in ticks del pulsante "Non adesso"
              setShowPopupInstall(false);
            }}
            autoFocus
          />

          <Button
            className="button-popup"
            label="Ok"
            icon="pi pi-check"
            onClick={() => {
              installPWA();
              setShowPopupInstall(false);
            }}
            autoFocus
          />
        </div>
      );
    }
  };

  const headerContent = (
    <div className="flex justify-content-start align-items-center">
      <img
        src={process.env.REACT_APP_IMG_INSTALL ? process.env.REACT_APP_IMG_INSTALL : 'MySalusAPP_PITTOGRAMMA_WHITE.svg'}
        alt=""
        className="logo-popup-install mr-2"
      />
      <div className="ml-2">Installa { process.env.REACT_APP_TITLE } </div>
    </div>
  );

  return (
    <div className="relative">
      <div className="position-popup">
        <Dialog
          modal={true}
          className="position-popup"
          visible={showPopupInstall}
          onHide={() => {
            hiddenPopup();
          }}
          header={headerContent}
          closable={true}
          footer={footerContent}
        >
          <p className={ 'popup-install-subtitle ' + (isIos() ? '' : 'mb-4') }>
            Installa l'app sul tuo dispositivo e sfrutta al meglio le funzionalità.
          </p>

          {isIos() ? (
            <ol className="popup-install-list">

              <li>
                <div className="flex flex-row align-content-end">
                  <div className="align-content-end">
                    Tocca 
                  </div>
                  <div>
                  <i className="align-content-end bi bi-box-arrow-up icone-apple-browser"></i>
                  </div>
                </div>
              </li>

              <li>
              {/* <span>Aggiungi alla schermata Home </span>
              <i className="bi bi-plus-square icone-apple-browser"></i> */}

                <div className="flex flex-row align-content-end">
                  <div className="align-content-end">
                    Aggiungi alla schermata Home
                  </div>
                  <div>
                  <i className="align-content-end bi bi-plus-square icone-apple-browser"></i>
                  </div>
                </div>
              </li>

              <li>
                <span>Tocca su <b className="ml-1">Aggiungi</b></span>
              </li>
            </ol>
            // // <div className="mt-2 flex justify-content-end">
            // //   <span>Tocca </span>
            // //   
            // //   <span>
            // //     <span><br />poi </span>
            // //     <b>Aggiungi a home</b>
            // //     <i className="bi bi-plus-square icone-apple-browser ml-2 mr-1"></i>
            // //     <span></span>
            // //   </span>
            // //   <span>
            // //     <br />
            // //     infine <b>Aggiungi.</b>
            // //   </span>
            // // </div>
            // <div className="flex justify-content-end w-full">
            //   <div>Tocca <i className="bi bi-box-arrow-up icone-apple-browser"></i></div>
            //   <div>poi <b>Aggiungi a home</b>
            //   <i className="bi bi-plus-square icone-apple-browser ml-2 mr-1"></i>
            //   </div>
            //   <div></div>
            // </div>
          ) : (
            <></>
          )}
        </Dialog>
      </div>
    </div>
  );
}
